// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__JhNjE","nav":"Menu_nav__ggpVh","on":"Menu_on__T+PXM","icon":"Menu_icon__wSxe+"};